module.exports = __webpack_public_path__ + "img/search.46d20f9b.svg";